import React from "react";

/**
 * A no-op authentication provider for local development.
 * Replaces Auth0Provider so the app renders without an Auth0 tenant.
 * The actual dev identity is supplied by the useAuth() hook.
 */
const DevAuthenticationProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

export default DevAuthenticationProvider;
